import { ReactNode } from "react";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../../components/modal/Dialog";

type CheckoutDialogProps = {
  isOpen: boolean;
  title: string;
  description: string;
  children: ReactNode;
  onDismiss?: () => void;
};

export const CheckoutDialog = ({
  isOpen,
  title,
  description,
  children,
  onDismiss,
}: CheckoutDialogProps) => {
  return (
    <Dialog
      active={isOpen}
      onDismiss={onDismiss}
      className="m-4 h-fit max-h-[calc(100dvh-2rem)]"
    >
      <DialogNavigation
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={onDismiss}
        title={title}
        description={description}
      />
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};
